import "./Universities.scss";
import {
  Card,
  Layout,
  Button,
  notification,
  Skeleton,
  Col,
  Row,
  Empty,
  Space,
  Table,
  Flex,
  Modal,
} from "antd";
import React, { useEffect, useState } from "react";
import type { TableProps } from "antd";
import { DeleteOutlined, FormOutlined, PlusOutlined } from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";
import {
  PageSetting,
  Query,
  SortMode,
  UniversityMessages,
  UniversityRaw,
} from "../../..";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import store from "../../../../controllers/store";
import { find } from "../../../../controllers/store/actions/universities/get-universities-actions";
import { findById } from "../../../../controllers/store/actions/universities/update-universities-actions";
import { remove } from "../../../../controllers/store/actions/universities/delete-university-action";
import { clear } from "../../../../controllers/store/actions/universities/create-university-action";
import NewUniversityModal from "../../../components/Forms/Modal/Universities/NewUniversity";
import UpdateUniversityModal from "../../../components/Forms/Modal/Universities/UpdateUniversity";

const { confirm } = Modal;
const { Header, Content } = Layout;
const dispatch = store.dispatch;

const query: Query = { filter: {} };
const Universities: React.FC = () => {
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [visibleUpdateModal, setVisibleUpdateModal] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(PageSetting.limit);
  const [api, contextHolder] = notification.useNotification();
  const universitiesState = useSelector((state: any) => state.universities);
  const updatedUniversityState = useSelector(
    (state: any) => state.updatedUniversity
  );
  const deletedUniversityState = useSelector(
    (state: any) => state.deletedUniversity
  );
  const createdUniversityState = useSelector(
    (state: any) => state.createdUniversity
  );
  const userState = useSelector((state: any) => state.user.user);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const columns: TableProps<UniversityRaw>["columns"] = [
    {
      title: "Nombre de la institución",
      dataIndex: "institution_name",
      key: "institution_name",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Email",
      dataIndex: "contact_email",
      key: "contact_email",
    },
    {
      title: "Ciudad",
      dataIndex: "municipality",
      key: "municipality",
    },
    {
      title: "Departamento",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Acreditada",
      dataIndex: "is_accredited",
      key: "is_accredited",
    },
    {
      title: "Fuente",
      dataIndex: "source",
      key: "source",
    },
    {
      title: "Reconocimiento MinCiencia",
      dataIndex: "recognized_min",
      key: "recognized_min",
    },
    {
      title: "Fecha de expedición",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Vigencia",
      dataIndex: "current_date",
      key: "current_date",
    },
    {
      title: "Última actualización",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "Acciones",
      key: "action",
      fixed: "right",
      width: 250,
      render: (_, record: UniversityRaw) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              if (record.id) {
                dispatch(findById(record.id));
                console.log("record", record);
              }
              setVisibleUpdateModal(!visibleUpdateModal);
            }}
            size="small"
            icon={<FormOutlined />}
          >
            Modificar
          </Button>
          <Button
            type="default"
            onClick={() => {
              confirm({
                okType: "primary",
                okText: "Borrar",
                cancelText: "Cancelar",
                title: UniversityMessages.Title,
                content: UniversityMessages.UniversitiesConfirmDeleteMessage,
                onOk: async () => {
                  if (record.id) {
                    await dispatch(remove(record.id));
                    dispatch(find(page, pageSize, query));
                  }
                },
                onCancel() {},
              });
            }}
            size="small"
            icon={<DeleteOutlined />}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];

  const showCreatedUniversityMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: UniversityMessages.Title,
      description: UniversityMessages.UniversityCreated,
    });
    dispatch(clear());
    return null;
  };

  const showDeletedUniversityMessage = () => {
    api["success"]({
      key: 1,
      message: UniversityMessages.Title,
      description: UniversityMessages.UniversitiesDeleteSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  const showUpdatedUniversityMessage = () => {
    api["success"]({
      key: 1,
      message: UniversityMessages.Title,
      description: UniversityMessages.UniversityUpdateSuccessMessage,
    });

    dispatch(clear());
    return null;
  };

  useEffect(() => {
    dispatch(find(1, pageSize, { filter: {} }));
    setInitialDataLoaded(true);
  }, [pageSize]);

  const handleSearch = (value: string) => {
    setSearchTerm(value);
    if (value) {
      query.search = value;
      query.meta = "filter_count";
    } else {
      delete query.search;
    }
    dispatch(find(1, pageSize, query));
  };

  return (
    <Layout className="universities-layout">
      {contextHolder}
      {createdUniversityState.createdUniversity
        ? showCreatedUniversityMessageSuccess()
        : null}
      {deletedUniversityState.removed ? showDeletedUniversityMessage() : null}
      {updatedUniversityState.updatedUniversity
        ? showUpdatedUniversityMessage()
        : null}
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="universities-content">
        <Card className="universities-card">
          <Col xs={24} sm={12} md={8} lg={12}>
            <h1 className="heading-content-title">
              Entidades
              <span className="heading-content-subtitle">
                Instituciones (IES)
              </span>
            </h1>
            <br />
          </Col>
          <NewUniversityModal
            visible={visibleCreateModal}
            onCreated={() => {
              setVisibleCreateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleCreateModal(false);
            }}
          />
          <UpdateUniversityModal
            university={updatedUniversityState.university}
            visible={visibleUpdateModal}
            onUpdated={() => {
              setVisibleUpdateModal(false);
              dispatch(find(page, pageSize, query));
            }}
            onCancel={() => {
              setVisibleUpdateModal(false);
            }}
          />
          {!initialDataLoaded && universitiesState?.list?.length === 0 ? (
            <>
              <br />
              <br />
              <br />
              <br />
              <Empty
                image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                imageStyle={{ height: 60 }}
                description={<span>No tienes instituciones aún</span>}
              >
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setVisibleCreateModal(!visibleCreateModal);
                  }}
                  type="primary"
                >
                  Agregar universidad
                </Button>
              </Empty>
              <br />
              <br />
              <br />
              <br />
            </>
          ) : (
            <>
              <Row
                gutter={[8, 8]}
                style={{
                  width: "100%",
                  marginBottom: 20,
                  alignItems: "center",
                }}
              >
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-start"}>
                    <Search
                      placeholder="Buscar"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onSearch={handleSearch}
                      enterButton
                    />
                  </Flex>
                </Col>
                <Col xs={24} sm={12} md={8} lg={12}>
                  <Flex vertical={true} align={"flex-end"}>
                    <Button
                      type="primary"
                      onClick={() => setVisibleCreateModal(!visibleCreateModal)}
                      size="middle"
                      icon={<PlusOutlined />}
                    >
                      Agregar universidad
                    </Button>
                  </Flex>
                </Col>
              </Row>
              <Skeleton
                loading={universitiesState.isLoading}
                active
                className="full-width"
              >
                <Table
                  scroll={{ x: 2500 }}
                  sticky={{ offsetHeader: 0 }}
                  pagination={{
                    locale: {
                      jump_to: "Ir a",
                      items_per_page: "Items por pagina",
                    },
                    total:
                      universitiesState.meta?.total_count ||
                      universitiesState.meta?.filter_count,
                    current: page,
                    pageSize: PageSetting.limit,
                    onChange: (page) => {
                      dispatch(find(page, pageSize, query));
                      setPage(page);
                    },
                    onShowSizeChange: (pageSize) => {
                      dispatch(find(page, pageSize, query));
                      setPageSize(pageSize);
                    },
                  }}
                  locale={{ emptyText: "Sin Resultados." }}
                  columns={columns}
                  dataSource={universitiesState.list}
                />
              </Skeleton>
            </>
          )}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Universities;
